import { logger } from 'Utils/Logger';
import { attachEventListener, getDomElement, removeEventListener } from './Browser';
import { getDefaultConfig } from 'Utils/Store';

const paymentIframeSelector = 'iframe[name="paymentpage"]';

export const filterByEventId = ({ data: { event_id: eventId = '', data = {} } }) => ({ eventId, data });

export const initPaymentIframe = () => {
  getDomElement('form#evPaymentIframe').submit();
};

const paymentIframePostEvent = (eventId, data) => {
  const paymentFrameEl = getDomElement(paymentIframeSelector);
  if (paymentFrameEl && paymentFrameEl.contentWindow) {
    const { evPaymentFrameUrl } = getDefaultConfig();
    paymentFrameEl.contentWindow.postMessage({ data, event_id: eventId }, evPaymentFrameUrl);
  } else {
    console.debug(`Error: No Evergent Payment iframe found with name 'paymentpage'`);
  }
};

export const paymentIframePostAndListen = (EVENT_NAME, payload = {}) => {
  if (!EVENT_NAME) {
    return Promise.reject(new Error('Payment Iframe: EVENT_NAME missing'));
  }
  const requestId = `${EVENT_NAME}_REQUEST`;
  const responseId = `${EVENT_NAME}_RESPONSE`;

  return new Promise((resolve) => {
    function processListenEvent(eventData) {
      const { eventId, data } = filterByEventId(eventData);
      if (eventId === responseId) {
        logger.completed(`payment iframe ${EVENT_NAME}`, data);
        removeEventListener('message', processListenEvent);
        resolve(data);
      }
    }
    attachEventListener('message', processListenEvent);
    logger.started(`payment iframe ${EVENT_NAME}`, payload);
    paymentIframePostEvent(requestId, payload);
  });
};
